import { Bar } from "vue-chartjs";
import * as d3 from "d3";
export default {
    extends: Bar,
    props: {
        channelId: String,
        title: String,
    },
    data: () => ({
        labels: [],
        data: [],
        femaleData: [],
        maleData: [],
        otherData: [],
        noneData: [],
        // full copies for filtering
        fullLabels: [],
        fullFemaleData: [],
        fullMaleData: [],
        fullOtherData: [],
        fullNoneData: []
    }),
    mounted() {
        this.logTest();
        this.loadData();
        if (this.$store && this.$store.watch) {
            this.$store.watch(
                state => state.dateRange,
                () => {
                    this.filterAndRender();
                }
            );
        }
    },
    watch: {
        channelId(){
            this.resetData();
            this.loadData();
        }
    },
    methods: {
        loadData: function() {
            d3.csv(`https://radio-kollen-public.s3-eu-west-1.amazonaws.com/${this.channelId}-collection.csv`, data => {
                this.fullLabels.push(data["date"]);
                const total = parseInt(data['female'])+parseInt(data['male'])+parseInt(data['other'])+parseInt(data['unknown']);
                this.fullFemaleData.push(parseInt(data['female'])/total*100);
                this.fullMaleData.push(parseInt(data['male'])/total*100);
                this.fullOtherData.push(parseInt(data['other'])/total*100);
                this.fullNoneData.push(parseInt(data['unknown'])/total*100);
            }).then(() => {
                this.filterAndRender();
            });
        },
        filterAndRender: function() {
            const start = this.$store && this.$store.state.dateRange.start ? this.$store.state.dateRange.start : null;
            const end = this.$store && this.$store.state.dateRange.end ? this.$store.state.dateRange.end : null;
            const labels = [];
            const female = [];
            const male = [];
            const other = [];
            const none = [];
            for (let i = 0; i < this.fullLabels.length; i++) {
                const date = this.fullLabels[i];
                if ((start === null || date >= start) && (end === null || date <= end)) {
                    labels.push(date);
                    female.push(this.fullFemaleData[i]);
                    male.push(this.fullMaleData[i]);
                    other.push(this.fullOtherData[i]);
                    none.push(this.fullNoneData[i]);
                }
            }
            this.labels = labels;
            this.femaleData = female;
            this.maleData = male;
            this.otherData = other;
            this.noneData = none;
            this.renderChart(
                {
                    labels: this.labels,
                    datasets: [
                        {
                            type: "bar",
                            label: "Kvinnliga Artister",
                            backgroundColor: "#f87979",
                            data: this.femaleData
                        },
                        {
                            type: "bar",
                            label: "Manliga Artister",
                            backgroundColor: "#a5CC82",
                            data: this.maleData
                        },
                        {
                            type: "bar",
                            label: "Icke-binära Artister",
                            backgroundColor: "#a6dCf2",
                            data: this.otherData
                        },
                        {
                            type: "bar",
                            label: "Ingen Information",
                            backgroundColor: "#888888",
                            data: this.noneData
                        }
                    ]
                },
                {
                    title: {
                        display: false,
                        text: `Kanal: ${this.title}`
                    },
                    scales: {
                        yAxes: [
                            {
                                stacked: true,
                                ticks: {
                                    min: 0,
                                    max: 100,
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Procent (%)'
                                }
                            }
                        ],
                        xAxes: [
                            {
                                stacked: true,
                                categoryPercentage: 0.5,
                                barPercentage: 1
                            }
                        ]
                    },
                    legend: {
                        display: true
                    },
                    responsive: true,
                    animation: false,
                    maintainAspectRatio: false
                }
            );
        },
        logTest: function() {
            //console.log("Hello!");
        },
        resetData: function (){
            this.labels = [];
            this.data = [];
            this.femaleData = [];
            this.maleData = [];
            this.otherData = [];
            this.noneData = [];
            this.fullLabels = [];
            this.fullFemaleData = [];
            this.fullMaleData = [];
            this.fullOtherData = [];
            this.fullNoneData = [];
        }
    }
};
